import { h } from "preact";

interface JcbIconProps {
  opacity?: number;
}

const JcbIcon = ({ opacity = 1 }: JcbIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="26"
    fill="none"
    viewBox="0 0 40 26"
    opacity={opacity}
  >
    <g clip-path="url(#a)">
      <path fill="#fff" d="M0 0h40v26H0V0Z" />
      <path
        fill="#fff"
        d="M36.6 20.66a5.22 5.22 0 0 1-5.22 5.22H3V5.22A5.22 5.22 0 0 1 8.22 0H36.6v20.66Z"
      />
      <path
        fill="url(#b)"
        d="M27.36 15.36h2.15l.27-.02a.96.96 0 0 0 .76-.96 1 1 0 0 0-.76-.97c-.06-.02-.19-.02-.27-.02h-2.15v1.97Z"
      />
      <path
        fill="url(#c)"
        d="M29.27 1.75a3.74 3.74 0 0 0-3.74 3.73v3.89h5.28c.12 0 .26 0 .37.02 1.19.06 2.07.67 2.07 1.74 0 .84-.6 1.56-1.7 1.7v.05c1.2.08 2.13.76 2.13 1.8 0 1.13-1.03 1.87-2.38 1.87h-5.8v7.6H31a3.74 3.74 0 0 0 3.73-3.74V1.75h-5.46Z"
      />
      <path
        fill="url(#d)"
        d="M30.27 11.38c0-.5-.35-.82-.76-.89l-.2-.02h-1.95v1.81h1.95c.06 0 .18 0 .2-.02a.87.87 0 0 0 .76-.88Z"
      />
      <path
        fill="url(#e)"
        d="M8.6 1.75a3.74 3.74 0 0 0-3.73 3.73v9.22a7.4 7.4 0 0 0 3.22.85c1.3 0 2-.78 2-1.85V9.34h3.2v4.34c0 1.68-1.05 3.06-4.6 3.06-2.16 0-3.84-.47-3.84-.47v7.86h5.48a3.74 3.74 0 0 0 3.74-3.74V1.75H8.6Z"
      />
      <path
        fill="url(#f)"
        d="M18.94 1.75a3.74 3.74 0 0 0-3.74 3.73v4.9c.94-.8 2.59-1.32 5.24-1.2 1.41.06 2.93.45 2.93.45v1.58a7.1 7.1 0 0 0-2.83-.82c-2.01-.14-3.23.84-3.23 2.57 0 1.74 1.22 2.73 3.23 2.57a7.46 7.46 0 0 0 2.83-.82v1.58s-1.5.39-2.93.45c-2.65.12-4.3-.4-5.24-1.2v8.63h5.48a3.74 3.74 0 0 0 3.74-3.74V1.75h-5.48Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1="25.52"
        x2="34.75"
        y1="14.38"
        y2="14.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#007940" />
        <stop offset=".23" stop-color="#00873F" />
        <stop offset=".74" stop-color="#40A737" />
        <stop offset="1" stop-color="#5CB531" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="25.52"
        x2="34.75"
        y1="12.94"
        y2="12.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#007940" />
        <stop offset=".23" stop-color="#00873F" />
        <stop offset=".74" stop-color="#40A737" />
        <stop offset="1" stop-color="#5CB531" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="25.52"
        x2="34.75"
        y1="11.37"
        y2="11.37"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#007940" />
        <stop offset=".23" stop-color="#00873F" />
        <stop offset=".74" stop-color="#40A737" />
        <stop offset="1" stop-color="#5CB531" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="4.86"
        x2="14.24"
        y1="12.94"
        y2="12.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#1F286F" />
        <stop offset=".48" stop-color="#004E94" />
        <stop offset=".83" stop-color="#0066B1" />
        <stop offset="1" stop-color="#006FBC" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="15.15"
        x2="24.25"
        y1="12.94"
        y2="12.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#6C2C2F" />
        <stop offset=".17" stop-color="#882730" />
        <stop offset=".57" stop-color="#BE1833" />
        <stop offset=".86" stop-color="#DC0436" />
        <stop offset="1" stop-color="#E60039" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h40v26H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default JcbIcon;
